/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  DirectIndex,
  HTTPValidationError,
  LatestEnrichedEquityUniverse,
  SriCategory,
} from '../models/index';
import {
    DirectIndexFromJSON,
    DirectIndexToJSON,
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
    LatestEnrichedEquityUniverseFromJSON,
    LatestEnrichedEquityUniverseToJSON,
    SriCategoryFromJSON,
    SriCategoryToJSON,
} from '../models/index';

export interface GetSampledUniverseRequest {
    directIndex: DirectIndex;
}

export interface LoadAccountAllocationTypesRequest {
    tradeDate: string;
}

/**
 * 
 */
export class UniverseApi extends runtime.BaseAPI {

    /**
     * Retrieve the latest enriched equity universe from the Data Warehouse.
     */
    async getLatestEnrichedEquityUniverseRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<LatestEnrichedEquityUniverse>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("RoleBasedJWTAuthenticator", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/portfolio-optimizer/latest-enriched-equity-universe`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(LatestEnrichedEquityUniverseFromJSON));
    }

    /**
     * Retrieve the latest enriched equity universe from the Data Warehouse.
     */
    async getLatestEnrichedEquityUniverse(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<LatestEnrichedEquityUniverse>> {
        const response = await this.getLatestEnrichedEquityUniverseRaw(initOverrides);
        return await response.value();
    }

    /**
     * Retrieve the latest SRI universe from the Data Warehouse.
     */
    async getLatestSriUniverseRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SriCategory>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("RoleBasedJWTAuthenticator", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/portfolio-optimizer/latest-sri-universe`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SriCategoryFromJSON));
    }

    /**
     * Retrieve the latest SRI universe from the Data Warehouse.
     */
    async getLatestSriUniverse(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SriCategory>> {
        const response = await this.getLatestSriUniverseRaw(initOverrides);
        return await response.value();
    }

    /**
     * Retrieve the sc_ids of the latest sampled NDVR 1500 universe the direct index tracks.
     */
    async getSampledUniverseRaw(requestParameters: GetSampledUniverseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters.directIndex === null || requestParameters.directIndex === undefined) {
            throw new runtime.RequiredError('directIndex','Required parameter requestParameters.directIndex was null or undefined when calling getSampledUniverse.');
        }

        const queryParameters: any = {};

        if (requestParameters.directIndex !== undefined) {
            queryParameters['direct_index'] = requestParameters.directIndex;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("RoleBasedJWTAuthenticator", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/portfolio-optimizer/sampled-universe`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Retrieve the sc_ids of the latest sampled NDVR 1500 universe the direct index tracks.
     */
    async getSampledUniverse(requestParameters: GetSampledUniverseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.getSampledUniverseRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Invalidate and update the latest enriched equity universe cache
     */
    async invalidateLatestEnrichedEquityUniverseCacheRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("RoleBasedJWTAuthenticator", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/portfolio-optimizer/latest-enriched-equity-universe-cache`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Invalidate and update the latest enriched equity universe cache
     */
    async invalidateLatestEnrichedEquityUniverseCache(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.invalidateLatestEnrichedEquityUniverseCacheRaw(initOverrides);
        return await response.value();
    }

    /**
     * Invalidate and update the latest SRI universe cache
     */
    async invalidateLatestSriUniverseCacheRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("RoleBasedJWTAuthenticator", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/portfolio-optimizer/latest-sri-universe-cache`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Invalidate and update the latest SRI universe cache
     */
    async invalidateLatestSriUniverseCache(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.invalidateLatestSriUniverseCacheRaw(initOverrides);
        return await response.value();
    }

    /**
     * Assign an allocation type to every position of the trade date via the waterfall and persist the result.
     */
    async loadAccountAllocationTypesRaw(requestParameters: LoadAccountAllocationTypesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: number; }>> {
        if (requestParameters.tradeDate === null || requestParameters.tradeDate === undefined) {
            throw new runtime.RequiredError('tradeDate','Required parameter requestParameters.tradeDate was null or undefined when calling loadAccountAllocationTypes.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("RoleBasedJWTAuthenticator", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/portfolio-optimizer/universe/allocation-types/trade-date/{trade_date}`.replace(`{${"trade_date"}}`, encodeURIComponent(String(requestParameters.tradeDate))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Assign an allocation type to every position of the trade date via the waterfall and persist the result.
     */
    async loadAccountAllocationTypes(requestParameters: LoadAccountAllocationTypesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: number; }> {
        const response = await this.loadAccountAllocationTypesRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
